const notFound = {
  title: "404",
  // NOTE: GR reference repo uses English copy here.
  message: "Oops! Page not found",
  backHome: "Return to Home",
};

export default notFound;

